import React from 'react'
import PropTypes from 'prop-types'

import { AgGridReact } from 'ag-grid-react'

const AtlasTree = React.forwardRef((props, ref) => {
  return (props.rowData.length > 0
    ? <div style={{ height: '650px', width: '100%' }} className="ag-theme-alpine">
      <AgGridReact
        treeData={true}
        ref={ref}
        getRowId={props.getRowId}
        getDataPath={props.getDataPath}
        rowData={props.rowData}
        columnDefs={props.columnDefs}
        defaultColDef={props.defaultColDef}
        autoGroupColumnDef={props.autoGroupColumnDef}
        animateRows={true}
        suppressRowClickSelection={true}
        suppressCellFocus={true}
        onSelectionChanged={props.onSelectionChanged} /> { /* we use this instead of onRowSelected because we get two events with onRowSelected that can happen in an order we don't like */ }
    </div>
    : <div></div>
  )
})

AtlasTree.displayName = 'AtlasTree' // fixes eslint issue for Component definition is missing display name  react/display-name

export default AtlasTree

AtlasTree.propTypes = {
  getRowId: PropTypes.func,
  getDataPath: PropTypes.func.isRequired,
  rowData: PropTypes.array.isRequired,
  columnDefs: PropTypes.array,
  defaultColDef: PropTypes.object,
  autoGroupColumnDef: PropTypes.object,
  onSelectionChanged: PropTypes.func
}
